import { motion, useAnimation } from 'framer-motion'
import React, { useContext, useEffect } from 'react'
import styled, { css } from 'styled-components'
import LayoutContext from './LayoutContext'
import media from 'css-in-js-media'
import InteractiveMapSlider from './InteractiveMapSlider'

const ActiveState = css`
    display: flex;
`

export const MapWrapper = styled(motion.div)`
    background-color: black;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: none;
    z-index: 11000;
    pointer-events: none;

    ${(props) =>
        props.active &&
        css`
            pointer-events: all;
        `}
`

const SliderWrapper = styled.div`
    height: 100%;
    width: 100%;
    display: none;
    .gatsby-image-wrapper {
        height: 100%;
    }
    .swiper-pagination {
        top: 48px;
        left: 80px;

        ${media('<desktop')} {
            top: 26px;
            left: 20px;
        }
    }
    .MapContent {
        top: 48px;

        ${media('<desktop')} {
            top: auto;
            bottom: 20px;
        }
    }

    ${(props) => props.active && ActiveState}
`

const MapInner = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`

const InteractiveMapPopup = ({}) => {
    const { isMap, isMapOpen } = useContext(LayoutContext)

    const controls = useAnimation()

    useEffect(() => {
        controls.start(isMapOpen ? 'active' : 'inactive') // Second should be 'inactive'
    }, [isMapOpen, controls])

    const MapAnimationStyles = {
        inactive: {
            opacity: 0,
            scale: 1.02,
            transitionEnd: { display: 'none' },
        },
        active: {
            opacity: 1,
            scale: 1,
            display: 'flex',
        },
    }

    return (
        <>
            <MapWrapper
                active={isMapOpen}
                animate={controls}
                variants={MapAnimationStyles}
                transition={{
                    type: 'spring',
                    stiffness: 10,
                    default: { duration: 0.5 },
                }}
            >
                {isMap.map((slide, index) => (
                    <SliderWrapper key={index} active={isMapOpen == slide.id && true}>
                        <MapInner>
                            <InteractiveMapSlider data={slide} isMap />
                        </MapInner>
                    </SliderWrapper>
                ))}
            </MapWrapper>
        </>
    )
}

export default InteractiveMapPopup
